<div style="background-color: #fff; min-width:400px; padding:15px; outline:none;">
	<div class="float-end" style="position:relative;z-index:100;">
		<span class="jmCloseBtn" (click)="close($event)"></span>
	</div>
	<div style="color:#000; min-height: 100px; z-index:99;">
		<div class="col-lg-12 col-md-12"><span style="font-size: 29px; padding:10px 0px;" [innerHTML]="title | safe:'html'"></span></div>
		<div class="col-sm-12 text-center" [hidden]="objectURL===''"><a href="javascript:void(0)" (click)="go(objectURL)">{{objectURL}}</a></div>
		<div class="col-lg-12 col-md-12" style="white-space: pre-wrap;" [innerHTML]="description | safe:'html'"></div>
	</div>
</div>
